// extracted by mini-css-extract-plugin
module.exports = {"label":"AttributeLabel_label__1Rp17","text":"AttributeLabel_text__3PmQz","checkbox":"AttributeLabel_checkbox__2dkUV"};